// React
import React, { useEffect, useState } from 'react';

// Prop types
import PropTypes from 'prop-types';

// Component
import MemoCardContent from './MemoCardContent';

// Const
import { MANAGER, MEMBER } from '../../../const';

// Mui styles
import { withStyles } from '@material-ui/core/styles';

// Mui core
import Box from '@material-ui/core/Box';

const styles = () =>
	({
		card : {
			width           : '100%',
			backgroundColor : 'white',
			borderRadius    : '7px',
			boxShadow       : '3px 3px 4px #aaa',
			height          : 'auto',
			fontSize        : '0.8rem'
		},
		header : {
			height       : '3rem',
			display      : 'flex',
			marginBottom : '1rem'
		},
		headerBgLeft : {
			width      : '1.5rem',
			height     : '90%',
			background : '#e5e5e2'
		},
		headerBgRight : {
			width      : 'calc(100% - 5.5rem)',
			height     : '90%',
			background : '#e5e5e2'
		},
		headerContent : {
			width                : '100%',
			background           : 'white',
			height               : '100%',
			border               : '1px solid white',
			borderTopLeftRadius  : '7px',
			borderTopRightRadius : '7px'
		},
		headerCenter : {
			color  : 'white',
			height : '90%'
		},
		headerTop : {
			width      : '4rem',
			height     : '20%',
			background : '#e5e5e2'
		},
		headerBottom : {
			width                   : '4rem',
			height                  : '80%',
			background              : '#999898',
			border                  : '1px solid #999898',
			borderBottomLeftRadius  : '7px',
			borderBottomRightRadius : '7px',
			display                 : 'flex',
			alignItems              : 'center',
			justifyContent          : 'center',
			fontSize                : '1rem'
		},
		underlined : {
			margin    : '0 1.5rem 2rem 1.5rem',
			borderTop : '1px solid #999898'
		},
		scrollBar : {
			overflow               : 'auto',
			height                 : '100%',
			paddingRight           : '1rem',
			'&::-webkit-scrollbar' : {
				background   : '#ccc',
				width        : '7px',
				height       : '7px',
				borderRadius : '100px'
			},
			'&::-webkit-scrollbar-thumb' : {
				background   : '#888',
				borderRadius : '100px',
				'&:hover'    : {
					background : '#555'
				}
			},
			'& > div:not(:last-child)' : {
				marginBottom : '5%'
			},
			'& > div:last-child' : {
				marginBottom : '1%'
			}
		}
	});

const MemoCard = ({
	classes,
	memo
}) =>
{
	const [ detailList, setDetailList ] = useState([]);

	useEffect(() =>
	{
		const details = [];

		memo.details.forEach((detail, index) =>
		{
			const comment = [];

			detail.comment.forEach((item) =>
			{
				comment.push({
					user      : item.user,
					timestamp : item.timestamp,
					title     : item.title,
					message   : item.message
				});
			});

			const memoDetails = {
				id          : index + 1,
				memoId      : memo.id,
				user        : detail.user,
				timestamp   : detail.timestamp,
				duration    : detail.duration,
				name        : memo.name,
				title       : detail.title,
				message     : detail.message,
				sms         : detail.sms,
				email       : detail.email,
				guestInput1 : detail.guestInput1,
				guestInput2 : detail.guestInput2,
				comment     : comment
			};

			details.push(memoDetails);
		});

		setDetailList(details);
	}, [ memo ]);

	return (
		<Box className={`${classes.scrollBar}`}>
			{detailList.map((item, no) => (
				<Box key={item.id} className={classes.card}>
					<Box className={classes.header}>
						<Box className={classes.headerBgLeft}>
							<Box className={classes.headerContent} />
						</Box>
						<Box className={classes.headerCenter}>
							<Box className={classes.headerTop} />
							<Box className={classes.headerBottom}>
								<p>{detailList.length - no}</p>
							</Box>
						</Box>
						<Box className={classes.headerBgRight}>
							<Box className={classes.headerContent} />
						</Box>
					</Box>
					<MemoCardContent cardType={MANAGER} detail={item} />
					{item.comment.map((member, index) => (
						<div key={index}>
							<Box className={classes.underlined} />
							<MemoCardContent cardType={MEMBER} detail={member} />
						</div>
					))}
				</Box>
			))}
		</Box>
	);
};

MemoCard.propTypes =
{
	classes : PropTypes.object.isRequired,
	memo    : PropTypes.object.isRequired
};

export default withStyles(styles)(MemoCard);
